<template>
  <div style="width: 100%;height: 100%;background-color: white">
    <div style="height: 20px"></div>
    <div style="height: 50px;margin: 0 20px;overflow-y: auto">
      <el-button type="primary" plain icon="el-icon-plus" @click="addServiceType(1)">服务内容</el-button>
      <el-input prefix-icon="el-icon-search" placeholder="输入搜索" v-model="searchKeyword" clearable style="width: 300px" ></el-input>
      <el-button type="primary" @click="searchFilterWord1">查询</el-button>
    </div>
    <div style="max-height: calc(100% - 100px);overflow-y: auto">
      <el-table element-loading-text="加载中，请耐心等待。" :data="tbdata1"
                border style="width: 100%" highlight-current-row ref="single">
        <el-table-column type="index" label="序号" width="70" align="center"></el-table-column>
        <el-table-column label="服务内容" min-width="110" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.is_service === 1">{{scope.row.typename}}</span>
          </template>
        </el-table-column>
        <el-table-column label="所属服务类型" min-width="90" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.is_service === 0">{{scope.row.typename}}</span>
            <span v-else>{{getUpTypeName(scope.row.upid)}}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="moduletag !== 2" label="所属组织" min-width="100" align="center">
          <template slot-scope="scope">
            <span>{{getOnOrg(scope.row)}}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="moduletag !== 2" prop="createtime" label="录入时间" min-width="90" align="center"></el-table-column>
        <el-table-column align="center" label="操作" width="90">
          <template slot-scope="scope">
            <i title="更新" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editServiceType(scope.row)"></i>
            <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delServiceType(scope.row)"></i>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top: 10px;height: 40px;text-align: center">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                     layout="total, sizes, prev, pager, next, jumper" :total="totalCells">
      </el-pagination>
    </div>
    <!--created update-->
    <el-dialog :visible.sync="addEditShow" v-if="addEditShow" width="600px" :show-close="true"
               :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <div><span>{{openTitle}}</span></div>
        <div class="line-title"></div>
      </div>
      <add-edit-stype :addEdit="addEditObj" v-model="addEditShow" @updatetype="updatetype"></add-edit-stype>
    </el-dialog>
  </div>
</template>

<script>
import {queryorg} from '../../api/organizer'
import {deletesuppliertype, querysuppliertype} from '../../api/serviceMark'
import addEditStype from './childComponents/addEditStype.vue'

export default {
  name: 'supplierContent',
  components: {addEditStype},
  data () {
    return {
      moduletag: 0,
      searchKeyword: '',
      orgData: [],
      tableData: [],
      tableData1: [],
      tbdata1: [],
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      openTitle: '',
      addEditShow: false,
      addEditObj: {
        isAdd: true,
        row: {},
        orgData: [],
        types: [],
        isService: 0
      }
    }
  },
  created () {
    this.moduletag = this.$store.state.user.moduletag
    this.getOrgData()
  },
  methods: {
    // 组织
    getOrgData () {
      this.loading = true
      queryorg().then(res => {
        this.orgData = res.data.org
        this.addEditObj.orgData = this.orgData
        this.querySupplierTypeData()
      }).catch(() => {
        this.loading = false
      })
    },
    updatetype () {
      this.querySupplierTypeData()
    },
    // 表格
    querySupplierTypeData () {
      let params = {
        page: 1,
        size: 99999
      }
      let data = {
        orgid: []
      }
      querysuppliertype(params, data).then(res => {
        this.loading = false
        // this.tableData = res.data.types
        let arr = []
        for (let i = 0; i < res.data.types.length; i++) {
          let obj = res.data.types[i]
          obj.servicerequirements = []
          obj.picturerequirements = []
          if (obj.service_requirements_tag === 1) {
            try {
              obj.servicerequirements = JSON.parse(obj.service_requirements)
            } catch (error) {
            }
          }
          if (obj.picture_requirements_tag === 1) {
            try {
              obj.picturerequirements = JSON.parse(obj.picture_requirements)
            } catch (error) {
            }
          }
          arr.push(obj)
        }
        this.tableData = arr
        this.addEditObj.types = res.data.types
        this.endTableData()
      }).catch(() => {
        this.loading = false
      })
    },
    endTableData () {
      this.currentPage = 1
      this.tableData1 = []
      this.tbdata1 = []
      for (let i = 0; i < this.tableData.length; i++) {
        if (this.tableData[i].is_service === 1) {
          this.tableData1.push(this.tableData[i])
        }
      }
      this.searchFilterWord1()
    },
    // table数据入口（tbdata）
    searchFilterWord1 () {
      let data = this.tableData1
      const vm = this
      const search = data.filter((val) => {
        if (val.typename.includes(vm.searchKeyword)) {
          return true
        }
      })
      vm.totalCells = search.length
      const arr = []
      for (let i = (vm.currentPage - 1) * vm.pageSize; i < vm.currentPage * vm.pageSize; i++) {
        if (!search[i]) {
          break
        }
        arr.push(search[i])
      }
      this.tbdata1 = arr
      console.log(99, this.tbdata1)
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.searchFilterWord1()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.searchFilterWord1()
    },
    // 新建服务类型
    addServiceType (val) {
      this.openTitle = '新建服务内容'
      this.addEditObj.isAdd = true
      this.addEditObj.row = {}
      this.addEditObj.isService = val
      this.addEditShow = true
    },
    // 编辑服务类型
    editServiceType (row) {
      this.openTitle = '编辑服务内容'
      this.addEditObj.isAdd = false
      this.addEditObj.row = row
      this.addEditShow = true
    },
    // 删除服务类型
    delServiceType (row) {
      let name = row.typename
      this.$confirm('此操作将永久删除该服务内容【' + name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          stids: [row.id]
        }
        deletesuppliertype(data).then(res => {
          if (this.tbdata1.length === 1 && this.currentPage > 1) {
            this.currentPage = this.currentPage - 1
          }
          this.$notify({ title: '成功', message: '成功删除服务内容', type: 'success', duration: 2000 })
          this.querySupplierTypeData()
        }).catch(() => {})
      }).catch(() => {})
    },
    getUpTypeName (upid) {
      let name = ''
      let upids = this.getOrgName1(parseInt(upid), [])
      for (let i = 0; i < upids.length; i++) {
        for (let j = 0; j < this.tableData.length; j++) {
          if (parseInt(upids[i]) === this.tableData[j].id) {
            name = this.tableData[j].typename + ' / ' + name
          }
        }
      }
      return name !== '' ? name.substring(0, name.length - 3) : ''
    },
    getOrgName1 (upid, arr) {
      arr.push(upid)
      for (let i = 0; i < this.tableData.length; i++) {
        if (parseInt(upid) === this.tableData[i].id) {
          arr = this.getOrgName1(this.tableData[i].upid, arr)
        }
      }
      return arr
    },
    getOnOrg (row) {
      for (let i = 0; i < this.orgData.length; i++) {
        if (row.orgid === this.orgData[i].id) {
          return this.orgData[i].name
        }
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/servicemanagement/supplierContent.vue